export default __webpack_public_path__ + "static/media/page-thumbnail.bc6b1633.png";